import { render, staticRenderFns } from "./BookingPaymentBar.vue?vue&type=template&id=085b5523&scoped=true&lang=pug&"
import script from "./BookingPaymentBar.vue?vue&type=script&lang=ts&"
export * from "./BookingPaymentBar.vue?vue&type=script&lang=ts&"
import style0 from "./BookingPaymentBar.vue?vue&type=style&index=0&id=085b5523&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085b5523",
  null
  
)

export default component.exports